// SavedPostsManager.js
import { useState, useCallback } from 'react';

export const useSavedPosts = () => {
  const [savedPosts, setSavedPosts] = useState(() => {
    // Initialize from localStorage during the initial render
    try {
      const saved = localStorage.getItem('savedPosts');
      return new Set(saved ? JSON.parse(saved) : []);
    } catch {
      return new Set();
    }
  });

  const savePost = useCallback((postId) => {
    setSavedPosts(prev => {
      const newSet = new Set(prev);
      newSet.add(postId);
      const savedArray = Array.from(newSet);
      localStorage.setItem('savedPosts', JSON.stringify(savedArray));
      return newSet;
    });
  }, []);

  const unsavePost = useCallback((postId) => {
    setSavedPosts(prev => {
      const newSet = new Set(prev);
      newSet.delete(postId);
      const savedArray = Array.from(newSet);
      localStorage.setItem('savedPosts', JSON.stringify(savedArray));
      return newSet;
    });
  }, []);

  const isSaved = useCallback((postId) => {
    return savedPosts.has(postId);
  }, [savedPosts]);

  return {
    savedPosts,
    savePost,
    unsavePost,
    isSaved
  };
};
